import type { WizardActionButtonProps } from "../WizardContext";

export interface WizardPrimaryButtonProps extends WizardActionButtonProps {
  isPending?: boolean;
}

/** Marker slot — Wizard reads props from this element rather than rendering it. */
export function WizardPrimaryButton(_props: WizardPrimaryButtonProps) {
  return null;
}
